import styled from 'styled-components';

export const ZoomButtonsContainer = styled.div`
  margin: ${({ theme: { token } }) => token.marginLG}px;
  height: fit-content;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginXS}px;
  border-radius: 50px;
  background-color: ${({ theme: { token } }) => token.colorBgContainer};

  .zoom-buttons-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ theme: { token } }) => token.marginXS}px;
    padding-top: ${({ theme: { token } }) => token.padding}px;
  }

  .zoom-level {
    color: ${({ theme: { token } }) => token.colorTextDescription};
  }

  .divider {
    margin: 0;
  }

  .reset-zoom-icon-container {
    padding: 0 ${({ theme: { token } }) => token.paddingXS}px ${({ theme: { token } }) => token.padding}px;
  }
`;
